/* eslint-disable no-underscore-dangle */
/* eslint-disable security/detect-object-injection */
import React, { useCallback, useMemo } from 'react';
import _ from 'lodash';
import { wizardProps, WizardPage } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import {  EntityUtil } from '@xengage/gw-portals-util-js';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { PremierConstants } from 'premier-constant-service';
import { useUpdateSubmissionServices, focusNextElement, screenReaderAnnounce, validationUtil } from 'premier-capability-hooks';
import presentationMetadata from './OperatorsPage.metadata.json5';
import './OperatorsPage.messages';
import  OperatorsComponent  from "../../components/Operator/OperatorComponent";

function OperatorsPage(props) {
    const {
        wizardData, updateWizardData, currentStep, callbackMap, viewModelService
    } = props;
    const { pageKey } = currentStep;
    const metadata = presentationMetadata[pageKey];
    const { initialValidation, onValidate } = useValidation('OperatorsPage');
    const { updateSubmission } = useUpdateSubmissionServices();
    const { lineName } = PremierConstants;
    
    const onNext = useCallback(
        async () => {

            const {productCode} = wizardData.value.baseData;
            const lobLineName = lineName[productCode];

            wizardData.value = await updateSubmission(lobLineName, 'OperatorsPage', wizardData);

            return wizardData;
        },
        [lineName, updateSubmission, wizardData]
    );

    const onSave = useCallback(
        async () => {

            const subVMCopy = _.clone(wizardData)
            const productCode = _.get(subVMCopy.value, 'baseData.productCode');

            validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.recMarLine.coverables.operators.value, ' ')

            const lobLineName = productCode ? lineName[productCode] : '';
            await updateSubmission(lobLineName, 'OperatorsPage', subVMCopy);
                            
            return wizardData;
        },
        [lineName, updateSubmission, wizardData]
    );

    const addOperators = useCallback(async () => {

            const operatorsObj = {
                tempID: EntityUtil.nextId()
            };

            const operatorListObj = {
                tempID: EntityUtil.nextId(),
                firNamFie: undefined,
                lasNamFie: undefined,
                datofBirFie: wizardData.baseData.primaryNamedInsured_Ext.dateOfBirth.value,
                perUsuBetOpe: 100,
                yeaasownofsimsizanboaFie: 0,
                yeaopesimsizandlarboaFie: 0
            };
            
            const autoRecordObj = {
                tempID: EntityUtil.nextId(),
                cleautrecFie: true
            };

            const { _xCenter, _dtoName } = wizardData.lobData.recMarLine.coverables.operators;

            const operatorsVM = viewModelService.create(operatorsObj, _xCenter, _dtoName);
            const operatorListVM = viewModelService.create(operatorListObj, operatorsVM.operatorList._xCenter, operatorsVM.operatorList._dtoName);
            const autoRecordVM = viewModelService.create(autoRecordObj, operatorsVM.autoRecord._xCenter, operatorsVM.autoRecord._dtoName);
            
            operatorsVM.operatorList.value = operatorListVM.value
            operatorsVM.autoRecord.value = autoRecordVM.value
            
            wizardData.lobData.recMarLine.coverables.operators.value = wizardData.lobData.recMarLine.coverables.operators.value || []
            

            wizardData.lobData.recMarLine.coverables.operators.pushElement(
                operatorsVM
            );
            updateWizardData(wizardData);
        
            setTimeout(() => {
                screenReaderAnnounce('Operator fields have been populated');
                focusNextElement(true, 0, 'firNamFie');
            }, 0);
        },
        [wizardData, viewModelService, updateWizardData]
    );

    const operatorsOverrides = useMemo(() => {
        const operatorsList = _.get(wizardData, 'lobData.recMarLine.coverables.operators', []);
        let overrides = [];

        if (!_.isEmpty(operatorsList)) {
            overrides = operatorsList?.children.map((operator, index) => ({
                    [`OperatorsComponent${index}`]: {
                        overrideProps: {
                            "@field": {
                                showRequired: true,
                                labelPosition: "left",
                            },
                        },
                        submissionVM: wizardData,
                        updateWizardData,
                        pathUpdated: `lobData.recMarLine.coverables.operators.children[${index}]`,
                        operatorsVm : operator,
                        index,
                        viewModelService
                    }
                }));
        }

        return Object.assign({}, ...overrides);
    }, [updateWizardData, viewModelService, wizardData]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        ...operatorsOverrides,
    };

    const resolveCallbackMap = {
        addOperators,
        ...callbackMap
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.content, wizardData, id, path, overrideProps),
        [metadata.content, wizardData, overrideProps]
    );

    const resolveComponentMap = {
        OperatorsComponent
    };

    const isDisableNext = () => _.get(wizardData, 'lobData.recMarLine.coverables.operators') ? !_.get(wizardData, 'lobData.recMarLine.coverables.operators').aspects.subtreeValid : true;

    return (
        <WizardPage
            skipWhen={() => initialValidation}
            disableNext={isDisableNext()}
            onNext={onNext}
            onSave={onSave}
        >           
        <ViewModelForm
            uiProps={metadata.content}
            model={wizardData}
            onModelChange={updateWizardData}
            callbackMap={resolveCallbackMap}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            componentMap={resolveComponentMap}
            // classNameMap={styles}
        />          
        </WizardPage>
    );
}

OperatorsPage.propTypes = wizardProps;
export default withViewModelService(OperatorsPage);
